import { useMemo } from 'react';
import { useMutation } from '@apollo/client'; 
import { v4 as uuidv4 } from 'uuid';
import { message } from 'antd';
import CREATE_ASSET from '../../gql/mutations/CREATE_ASSET';
  
const useCreateImageAsset = () => {
    const [ createAsset ] = useMutation( CREATE_ASSET );
    
    const createImageAsset = async ( file ) => {
        
        try {  
            const variables = {
                'input': {
                    'id': uuidv4(),
                    'name': file.name,
                    'type': 'IMAGE', 
                    'file': file
                }
            }; 
         
            const response = await createAsset( { variables } );    
            const success = !( response?.error || response?.errors && response?.errors?.length > 0 );
            const newAsset = response?.data?.result;

            if ( success && newAsset ) {
                return newAsset;
            } else {
                message.error( 'Error uploading image!' );
                return false;
            }
        } catch ( e ) { 
            console.error( e ); 
            message.error( 'Error uploading image!' );
            return false;
        }
    };

    return useMemo( () => {
        return {
            createImageAsset
        };
    }, [ ] );
};

export default useCreateImageAsset;
